import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EdpModalService } from "@edp-components/edp-modal";
import { IModalData } from "@edp-components/edp-modal/edp-modal.models";
import { LanguageTypeEnum } from "@edp-enums/language.enum";
import { SectionChallenge } from "@edp-models/benefits.model";
import { EdpSelectList } from "@edp-models/edp-select-list";
import { LanguageService } from "@edp-services/language.service";
import { SetMacroChallengeSubscription } from "@edp-store/actions/edpe.actions";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment";

@Component({
    selector: "edp-e-race-challenge-complete-modal",
    templateUrl: "./edp-e-race-challenge-complete-modal.component.html",
    styleUrls: ["./edp-e-race-challenge-complete-modal.component.scss"],
})
export class EdpERaceChallengeCompleteModalComponent implements OnInit {
    @Input() public data: IModalData;
    public form: FormGroup;
    public points = 0;
    public list: EdpSelectList[] = [];
    public date: string;
    public local: string;
    public isSaved = false;
    public challenge: SectionChallenge;

    constructor(
        private readonly translate: TranslateService,
        private edpModalService: EdpModalService,
        private formBuilder: FormBuilder,
        private store: Store<IAppState>,
        public languageService: LanguageService
    ) {}

    ngOnInit() {
        this.form = this.formBuilder.group({
            local: [null, [Validators.required]],
        });

        this.challenge = this.data.collection;
        this.points = this.challenge.numberOfZ;

        this.challenge.events.forEach(el => {
            this.list.push({
                value: el.id.toString(),
                text: el.name,
                selected: false,
            });
        });

        this.store.dispatch(new SetMacroChallengeSubscription({ userMacroChallengeId: this.challenge.userMacroChallengeId, id: null }));
    }

    public closeModal(action: boolean): void {
        this.edpModalService.close(action);
    }

    public close() {
        this.closeModal(true);
    }

    public submit() {
        if (!!this.form.valid) {
            this.isSaved = true;
            this.store.dispatch(
                new SetMacroChallengeSubscription({ userMacroChallengeId: this.challenge.userMacroChallengeId, id: this.selectedLocal.id })
            );
        }
    }

    public setSelectedOption(event) {
        const selectedLocal = this.challenge.events.find(el => el.id.toString() === event.value);
        this.form.get("local").setValue(selectedLocal);
        this.setFormattedDate();
        this.setLocal();
    }

    get selectedLocal() {
        return this.form.get("local").value;
    }

    private setFormattedDate() {
        const date = moment(this.selectedLocal.startDate, "YYYY-MM-DD")
            .locale(this.languageService.getLocale())
            .format("DD MMMM");
        const year = moment(this.selectedLocal.startDate, "YYYY-MM-DD")
            .locale(this.languageService.getLocale())
            .format("YYYY");
        const hours = moment(this.selectedLocal.startDate)
            .utc()
            .local()
            .format("HH:mm");
        this.date = ` <b>${date}</b> ${year} ${this.translate.instant("pt.edp.edponline.run.challenge.modal.at")} <b>${hours}</b>`;
    }

    private setLocal() {
        const local = this.selectedLocal.local.split(",");
        if (local[0] && local[1]) {
            this.local = ` <b>${local[0]}</b>, ${local[1]}`;
            return;
        }
        if (local[0] && !local[1]) {
            this.local = ` <b>${local[0]}</b>`;
            return;
        }

        if (!local[0] && local[1]) {
            this.local = ` ${local[1]}`;
            return;
        }
        this.local = null;
    }
}
